'use client';

import { PropsWithChildren } from 'react';
import DesktopLayout from './desktop';
import MobileLayout from './mobile';
import { LoginModal } from '~/components/ui/modals/LoginModal';
import { Hide, Show } from '@chakra-ui/react';
import { SearchModal } from '~/components/ui/modals/SearchModal';
import { getTabNameFromUrlPath } from '@habity/services';
import { usePathname } from 'next/navigation';
import { ListButtons } from '~/components/ui/buttons/ListButtons';
import { ProfileCompletionHandler } from '~/components/ui/handlers/ProfileCompletionHandler';
import { EnhancedLoginModal } from '~/components/ui/modals/EnhancedLoginModal';
import { ActionConfirmationModal } from '~/components/ui/modals/ActionConfirmationModal';
import {
  PropertySearchFlyout,
  ClientPortalDrawer,
} from '~/components/ui/drawers';
import { UrlParamsHandler } from '~/components/ui/handlers/UrlParamsHandler';

const SiteLayout = ({ children }: PropsWithChildren) => {
  const pathname = usePathname();

  return (
    <>
      <Show below="desktop">
        <MobileLayout>{children}</MobileLayout>
      </Show>

      <Hide below="desktop">
        <DesktopLayout>{children}</DesktopLayout>
      </Hide>

      <ListButtons />

      <LoginModal />
      <EnhancedLoginModal />
      <ActionConfirmationModal />

      <SearchModal tab={getTabNameFromUrlPath(pathname)} />

      <PropertySearchFlyout />

      <ClientPortalDrawer />

      {/* Handle URL parameters for opening modals/drawers */}
      <UrlParamsHandler />

      {/* Only render ProfileCompletionHandler on dashboard routes */}
      {pathname?.startsWith('/dashboard') && <ProfileCompletionHandler />}
    </>
  );
};

export default SiteLayout;
